export const USER_SIGN_IN = "V1_USER_SIGN_IN";
export const USER_SIGN_OUT = "V1_USER_SIGN_OUT";
export const USER_UPDATE_PASSWORD = "V1_USER_UPDATE_PASSWORD";
export const USER_UPDATE_DATA = "V1_USER_UPDATE_DATA"